import Renewal from "./views/Renewal";
import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import financials from "./components/financials";
import retakes from "./components/retakes";
import registrationCards from "./components/registrationCards";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "../dashboard/modules/auth/middleware/ProfileComplete";
import registrationDocument from "./components/registrationDocument";
import Checkout from "./components/Checkout";
// import RegistrationTab from "./components/RegistrationTab";
import RenewalProforma from "./components/RenewalProforma";
import CurrentRegistration from "./components/CurrentRegistration";
import RenewalReceipt from "./components/RenewalReceipt";

export default [
  {
    path: "/renewals",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "renewals",
        component: Renewal,
        children: [
          {
            path: "registrations",
            name: "RegistrationList",
            component: CurrentRegistration,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "registrationCards",
            name: "registrationCards",
            component: registrationCards,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "registrationDocument/:regNo",
            name: "RegistrationDocument",
            component: registrationDocument,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "financials",
            name: "Financials",
            component: financials,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "retakes",
            name: "Retakes",
            component: retakes,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "checkout/:code",
            name: "checkout",
            component: Checkout,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "renewal_proforma/:code",
            name: "RenewalProforma",
            component: RenewalProforma,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "renewal_receipt/:code",
            name: "RenewalReceipt",
            component: RenewalReceipt,
            meta: { middleware: [Auth, ProfileComplete] },
          },
        ],
      },
    ],
  },
];
